var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.712,
    height: 26,
    viewBox: "0 0 21.712 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1793",
    "data-name": "Group 1793",
    transform: "translate(-42.216 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    d: "M136.937,187.307a1.667,1.667,0,0,0,1.627-1.627v-3.8h1.087a1.027,1.027,0,0,0,1.087-1.087V169.937h-13.03v10.856a1.027,1.027,0,0,0,1.087,1.087h1.087v3.8a1.627,1.627,0,1,0,3.255,0v-3.8h2.173v3.8A1.667,1.667,0,0,0,136.937,187.307Z",
    transform: "translate(-81.151 -161.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1280",
    "data-name": "Path 1280",
    d: "M407.319,180.793a1.666,1.666,0,0,0,1.627-1.627v-7.6a1.627,1.627,0,0,0-3.255,0v7.6A1.667,1.667,0,0,0,407.319,180.793Z",
    transform: "translate(-345.018 -161.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1281",
    "data-name": "Path 1281",
    d: "M43.843,180.793a1.667,1.667,0,0,0,1.627-1.627v-7.6a1.627,1.627,0,0,0-3.255,0v7.6A1.667,1.667,0,0,0,43.843,180.793Z",
    transform: "translate(0 -161.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1282",
    "data-name": "Path 1282",
    d: "M139.434.164a.52.52,0,0,0-.758,0l-1.457,1.453-.067.067a6.436,6.436,0,0,0-2.912-.651h-.032a6.435,6.435,0,0,0-2.912.651l-.067-.067L129.771.164a.52.52,0,0,0-.758,0,.521.521,0,0,0,0,.757l1.41,1.41a5.874,5.874,0,0,0-1.224,1.1,6.381,6.381,0,0,0-1.48,3.773c0,.015,0,.03,0,.045q-.007.146-.007.294h13.03q0-.148-.007-.294c0-.015,0-.03,0-.045a6.378,6.378,0,0,0-1.48-3.773,5.87,5.87,0,0,0-1.224-1.1l1.41-1.41A.521.521,0,0,0,139.434.164Zm-7.927,5.481a.814.814,0,1,1,.814-.814A.814.814,0,0,1,131.508,5.645Zm5.432,0a.814.814,0,1,1,.814-.814A.814.814,0,0,1,136.94,5.645Z",
    transform: "translate(-81.152 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardAndroid);
export default __webpack_public_path__ + "static/media/dashboardAndroid.5b684694de26536f00c19e495a53082b.svg";
export { ForwardRef as ReactComponent };